import { render, staticRenderFns } from "./ItemImage.vue?vue&type=template&id=549ee515"
import script from "./ItemImage.vue?vue&type=script&lang=ts"
export * from "./ItemImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports